import {useCallback, useState} from "react";

export const useToggle = (isEnabledByDefault: boolean = true) => {
    const [isEnabled, setIsEnabled] = useState(isEnabledByDefault);

    const onEnabledToggle = useCallback(() => {
        setIsEnabled((prevState) => !prevState);
    }, []);

    return {
        isEnabled,
        onEnabledToggle,
    }
};
